import Layout from "@/components/feature/Layout";
import Breadcrumb from "@/components/feature/Breadcrumb";

const sections = [
  {
    title: "Gold & Silver Care",
    body: "Aurelin pieces are cast in solid recycled gold, sterling silver and platinum. To keep the finish quiet and even, remove your jewelry before showering, swimming, exercising or applying skincare.",
  },
  {
    title: "Storage",
    body: "Store each piece in its original Aurelin pouch, separately from other jewelry. Keep away from direct sunlight and humidity. Chains should be laid flat or gently coiled to prevent tangling.",
  },
  {
    title: "Water & Perfume",
    body: "Avoid contact with chlorine, salt water, perfume and cosmetic products, which can dull the surface over time. Always allow perfume and lotions to dry fully before wearing your jewelry.",
  },
  {
    title: "Cleaning",
    body: "Wipe pieces gently with the enclosed polishing cloth after wear. For a deeper clean, use lukewarm water with a drop of mild soap and a soft brush, then dry with a lint-free cloth. Complimentary professional cleaning is available at our atelier.",
  },
];

export default function Care() {
  return (
    <Layout>
      <section>
        <div className="shell pt-24 pb-16">
          <Breadcrumb items={[{ label: "Care Guide" }]} />
          <h1 className="mt-8 font-display text-5xl md:text-6xl text-black">Care Guide</h1>
          <p className="mt-4 text-graphite max-w-xl leading-relaxed">
            Considered advice for keeping your Aurelin pieces beautiful for a lifetime.
          </p>
        </div>
        <div className="shell pb-24 grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-8 md:col-start-3 space-y-10">
            {sections.map((s) => (
              <div key={s.title}>
                <h2 className="font-display text-2xl text-black">{s.title}</h2>
                <p className="mt-3 text-graphite leading-[1.9] text-[15px]">{s.body}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </Layout>
  );
}